// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/slider/index.scss
 ** module id = 393
 ** module chunks = 1
 **/